// ============================================================
// Cliente de la API pública TpcV2 — Fichas Técnicas
// Doc: docs/API.md
//
//   Endpoints usados: /categorias, /categoria/{id}, /alergenos
//
//   Local (dev):  http://intranet.test/api/tpc-v2  (vía proxy → /api/tpc-v2)
//   Producción:   https://sethotels.net/api/tpc-v2
//
// En desarrollo usamos rutas relativas para que el devServer.proxy de
// vue.config.js reenvíe a intranet.test sin problemas de CORS.
// ============================================================

const ORIGIN =
  process.env.VUE_APP_API_BASE ||
  (process.env.NODE_ENV === 'production' ? 'https://sethotels.net' : '')

export const API_BASE = `${ORIGIN}/api/tpc-v2`

async function getJSON(url) {
  const res = await fetch(url, { headers: { Accept: 'application/json' } })
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status} — ${url}`)
    err.status = res.status
    throw err
  }
  return res.json()
}

/**
 * Listado de categorías activas.
 * @returns {Promise<Array<{id:number,nombre:string,descripcion:string|null}>>}
 */
export function fetchCategorias() {
  return getJSON(`${API_BASE}/categorias`)
}

/**
 * Idiomas disponibles para el selector (dinámico, definido en la intranet).
 * El primero de la lista es el idioma base/por defecto.
 * @returns {Promise<Array<{locale:string,nombre:string,bandera:string|null}>>}
 */
export function fetchIdiomas() {
  return getJSON(`${API_BASE}/idiomas`)
}

/**
 * Catálogo completo de alérgenos activos (todos, no solo los referenciados).
 * Pensado para construir la sección "Mis alérgenos".
 * @param {string} locale
 * @returns {Promise<Array<{id:number,nombre:string,codigo:string|null,nota:string|null,icono_url:string}>>}
 */
export function fetchAlergenos(locale = 'es') {
  const params = new URLSearchParams({ locale })
  return getJSON(`${API_BASE}/alergenos?${params.toString()}`)
}

/**
 * Fichas técnicas de una categoría para un día de la semana (ISO 8601: 1=lun … 7=dom).
 * @param {number} categoriaId
 * @param {number} dia
 * @param {string} locale
 */
export function fetchCategoria(categoriaId, dia, locale = 'es') {
  const params = new URLSearchParams({ locale })
  if (dia != null) params.set('dia', String(dia))
  return getJSON(`${API_BASE}/categoria/${categoriaId}?${params.toString()}`)
}
